import React, { ReactElement, useState } from 'react';
import { useClearCartWishlistSearchAction } from 'b2b-apps/shop/cart/hooks';
import { useCheckPermissions, useLoginAction, useUserData } from 'b2b-apps/shop/context/hooks';
import { PERMISSION } from 'b2b-apps/shop/context/utils/permissions';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { AddToWishlistAction } from '../AddToWishlistAction';
import { Props } from './withContainer.types';

export const WithContainer = ({
  skus = [],
  styleType,
  className,
}: Props): ReactElement => {
  const t = useTranslate();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const { isLoggedIn } = useUserData();
  const hasUserWishlistAccessPermission = useCheckPermissions([PERMISSION.accessWishlist]);
  const clearCartWishlistsSearch = useClearCartWishlistSearchAction();
  const redirectToLogin = useLoginAction();
  const redirectReason = t('You have to log in to perform this action');

  const handleModalOpen = (): void => {
    if (!isLoggedIn) {
      return redirectToLogin(redirectReason);
    }

    setIsModalOpened(true);
  };

  const handleModalClose = () => {
    setIsModalOpened(false);
    clearCartWishlistsSearch();
  };

  return (
    <AddToWishlistAction
      onModalOpen={handleModalOpen}
      onModalClose={handleModalClose}
      isModalOpened={isModalOpened}
      skus={skus}
      isLoggedIn={isLoggedIn}
      hasUserWishlistAccessPermission={hasUserWishlistAccessPermission}
      styleType={styleType}
      className={className}
    />
  );
};
